export const SETTINGS_FETCH_REQUEST = 'SETTINGS:FETCH_REQUEST';
export const SETTINGS_FETCH_SUCCESS = 'SETTINGS:FETCH_SUCCESS';
export const SETTINGS_FETCH_FAILURE = 'SETTINGS:FETCH_FAILURE';

export const PREFERENCES_FEED_FETCH_REQUEST = 'PREFERENCES:FEED_FETCH_REQUEST';
export const PREFERENCES_FEED_FETCH_SUCCESS = 'PREFERENCES:FEED_FETCH_SUCCESS';
export const PREFERENCES_FEED_FETCH_FAILURE = 'PREFERENCES:FEED_FETCH_FAILURE';

export const SETTINGS_AUSTRALIA_FETCH_REQUEST = 'SETTINGS:AUSTRALIA_FETCH_REQUEST';
export const SETTINGS_AUSTRALIA_FETCH_SUCCESS = 'SETTINGS:AUSTRALIA_FETCH_SUCCESS';
export const SETTINGS_AUSTRALIA_FETCH_FAILURE = 'SETTINGS:AUSTRALIA_FETCH_FAILURE';
